import * as React from 'react';
import { connect } from 'react-redux';
import './Bling.css';
import { navigateTo } from '../../../actions/navigationActions';
import { setQuoteType, newMobileClientCheck } from '../../../actions/salesActions';
import { ProgressBar, Button } from 'react-bootstrap';
import { PRODUCT_BLING } from '../../../constants/constants';
import { GET_BLING_INSURANCE, PERSONAL_INFO, CELLPHONE_DETAILS, PORTABLE_POSSESSIONS } from '../../../routes/routes';

class GatherInfo extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            nextDisabled: true,
            loggedIn: this.props.auth.uid ? true : false,
        };

        this.handleRedirect = this.handleRedirect.bind(this);
        this.handleBack = this.handleBack.bind(this);
    }

    async handleRedirect() {
        var nextPage = PERSONAL_INFO;
        if (this.props.profile.policyId !== "" || this.props.cart.quoteId !== "") {
            await this.props.dispatchSetQuoteType();
            this.props.dispatchRedirectTo(CELLPHONE_DETAILS)
        }
        else {
            await this.props.dispatchSetQuoteType();
            this.props.dispatchRedirectTo(nextPage);
        }
    }

    async componentDidMount() {
    }

    async handleCarRiskDropdownToggle(e: any) {
        await this.setState({
            selectePortalPossessionsDropdown: !this.state.selectePortalPossessionsDropdown
        });
    }

    async handleBack(e: any) {
        this.props.dispatchRedirectTo(PORTABLE_POSSESSIONS)
    }

    public render() {
        return (
            <div className={this.state.loggedIn ? "pt-lg-5 pb-5 logged-in" : "pt-lg-5 pb-5 logged-out"}>
                <div className="col-12 text-lg-center text-md-center">
                    <div className="container portal-possession-risk">
                        <div className="row justify-content-center mobile-mt-60px">
                            <div className="col-lg-12 col-md-12">
                                <div className="row justify-content-center">
                                    <div className="col-2 col-md-3 col-lg-3 col-xl-2 pt-lg-2 text-center align-self-center">
                                        <div className="BackRectangle d-none d-lg-block d-md-block">
                                            <button onClick={this.handleBack} className="Back cursor-pointer"><img src="./images/OnlineQuotation/icon-back-button-desktop.png" alt="" /></button>
                                        </div>
                                        <div className="sidenav d-lg-none d-md-none" id="mySidenav">
                                            <button onClick={this.handleBack} className="Back cursor-pointer" id="about"><img src="./images/OnlineQuotation/icons-navigation-quote-back-btn.png" alt="" /></button>
                                        </div>
                                    </div>
                                    <div className="col-10 col-md-9 col-lg-9 col-xl-10 p-0 text-center align-self-center">
                                        <div>
                                            <ProgressBar variant="success" now={35} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container mt-32px mobile-mt-20px">
                        <div className="row justify-content-center">
                            <div className="col-lg-12 col-md-12 nopa">
                                <div className="row noma">
                                    <div className="col nopa"></div>
                                    <div className="col-lg-10 nopa">
                                        <div className="ssp-addportable-possessions-crown-icon mt-0px text-center">
                                            <div className="ssp-sales-journey-crown-icon" title="Add portable possessions"></div>
                                        </div>
                                        <div className="ssp-bling-gather-info-contentholder mt-21px mobile-mt-17px mb-15px mobile-mb-20px text-center ssp-bling-gather-info-p-holder">
                                            <div className="font-size-16px font-weight-500">
                                                If you’re insuring a cellphone for someone else, please have the following info ready:
                                            </div>
                                        </div>
                                        <div className="row noma ssp-bling-gather-info-contentholder display-inline-block">
                                            <div className="col-12 nopa">
                                                <ul className="gather-info-checklist text-left">
                                                    <li>The person’s name and surname.</li>
                                                    <li>Their ID no.</li>
                                                    <li>The number of the cellphone that’s being insured.</li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="row noma justify-content-center mt-43px">
                                            <div className="col-12 col-lg-4 nopa okay-button-holder">
                                                <Button className="btn btn-block btn-solid-red button-width gather-info-button" id="OkayButton" onClick={this.handleRedirect}>Okay</Button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        auth: state.firebase.auth,
        sales: state.sales,
        cart: state.cart,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchRedirectTo: (destination) => dispatch(navigateTo(destination)),
        dispatchCreditHistoryCheck: () => dispatch(newMobileClientCheck("", true,null)),
        dispatchSetQuoteType: () => dispatch(setQuoteType(PRODUCT_BLING)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(GatherInfo);